// extracted by mini-css-extract-plugin
module.exports = {"root":"ExploreTabs_root__1i3zq","tab":"ExploreTabs_tab__5Q9N0","active":"ExploreTabs_active__3Kfed"};